
import { Vue, Component } from 'vue-property-decorator'
import LogoutButton from './LogoutButton.vue'
import { ActionTypes as authentication } from '../store/modules/authentication/types'
import { ActionTypes as customer } from '../store/modules/customer/types'

@Component({
    components: {
        LogoutButton,
    },
})
export default class RegistrationProgress extends Vue {
    signupStepUrl =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/step1_g.png'
    editStepUrl =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/step2_g.png'
    completeStepUrl =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/step3_g.png'
    arrowUrl =
        'https://usermodel-assets.s3-ap-northeast-1.amazonaws.com/musio-english-assets/Arrow.png'

    getPath(): string {
        return this.$router.currentRoute.path
    }
    logout(): void {
        this.$store.dispatch(authentication.LOGOUT_REQUEST).then(() => {
            this.$store.commit(customer.STATE_RESET)
            this.$router.push('/')
        })
    }
}
